import { css } from 'lit';
export default css `
  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }
`;
//# sourceMappingURL=styles.js.map